// @ts-nocheck
import React, {Component} from 'react'
import Styles from './HcoDetails.module.css'
import apiFetch from '../../api/apiFetch'
import Loading from '../../components/Loading/Loading'
import DetailsInformation from './components/Details_Information'
//import DetailsPriAddress from './components/Details_PriAddress'
import AddressAlignment from "./components/address-alignment/AddressAlignment";
import DetailsAffiliations from './components/Details_Affiliations'
import DetailsChangeRequests from './components/Details_ChangeRequests'
import DetailsEdit from './components/Details_Edit'
import TdddDetails from './components/Details_TDDD'
import TdddDetailsEdit from './components/Details_TDDD_Edit'
import HcoRequestSuccess from './components/HcoRequestSuccess'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../AppInsights';
import { withRouter } from '../../utility/withRouter';

class HcoDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            spinning: false,
            pathError: false,
            editsubmitted: false,
            addTdddsuccess: false,
            hasTeamAffiliations: false,
            // section state: null = loading, [] = empty
            data: null,
            affiliations: null,
            change: null,
            tdddHistory: null,
            msl: {},
            // Local optimistic toggle delta — seeded from core DB flags on load
            toggleState: { crm: undefined, spend: undefined, ctms: undefined },
        };
    }

    addTo(index, i, added, addSpend) {
        let json = {}
        if (added) {
            if (i === 0) {
                json.REQUEST_TYPE = "Remove from - Spend";
            } else if (i === 1) {
                json.REQUEST_TYPE = "Remove from - CRM";
            } else if (i === 2) {
                json.REQUEST_TYPE = "Remove from - CTMS";
            }
        } else {
            if (i === 0) {
                json.REQUEST_TYPE = "Add to - Spend";
            } else if (i === 1) {
                json.REQUEST_TYPE = "Add to - CRM";
            } else if (i === 2) {
                json.REQUEST_TYPE = "Add to - CTMS";
            }
        }

        this.setState(prev => ({
            toggleState: {
                ...prev.toggleState,
                ...(i === 0 ? { spend: !added } : {}),
                ...(i === 1 ? { crm:   !added } : {}),
                ...(i === 2 ? { ctms:  !added } : {}),
            }
        }))

        json.ORG_ID = this.state.data.ORG_ID
        json.REQUESTOR_ID = this.props.user.email
        json.REQUESTOR_NAME = this.props.user.userName
        json.REQUESTOR_TEAM = this.props.user.team
        json.REQUESTOR_TERR = this.props.user.terr

        apiFetch('/api/v2/global/change-request', json).then(() => {
            if (addSpend) {
                let json = {}
                json.REQUEST_TYPE = "Add to - Spend";
                json.ORG_ID = this.state.data.ORG_ID
                json.REQUESTOR_ID = this.props.user.email
                json.REQUESTOR_NAME = this.props.user.userName
                json.REQUESTOR_TEAM = this.props.user.team
                json.REQUESTOR_TERR = this.props.user.terr
                this.setState(prev => ({ toggleState: { ...prev.toggleState, spend: !added } }))
                apiFetch('/api/v2/global/change-request', json)
            }
        })
    }

    closeEdit() {
        this.setState({editScreen: undefined})
    }

    refresh(data) {
        let temp = this.state.data;
        let keys = Object.keys(data[0])
        for (let i = 0; i < Object.keys(data[0]).length; i++) {
            if (data[0][keys[i]] !== null) {
                temp[keys[i]] = data[0][keys[i]]
            }
        }
        this.setState({data: temp})
    }

    submitEdit(json, list) {

        if (this.state.editsubmitted === true) { return; }

        this.setState({ editsubmitted: true })

        if (!list) {
            json.ORG_ID = this.state.data.ORG_ID
            json.REQUESTOR_ID = this.props.user.email
            json.REQUESTOR_NAME = this.props.user.userName
            json.REQUESTOR_TEAM = this.props.user.team
            json.REQUESTOR_TERR = this.props.user.terr
        }
        apiFetch('/api/v2/global/change-request', json).then((data) => {
            this.setState({ editsubmitted: false });
            this.editScreen(11);
            this.setChange(data);
        }).catch(() => {
            this.setState({ editsubmitted: false });
        })
    }

    editScreen(i, id) {
        this.setState({
            editScreen: <DetailsEdit
                editScreen={this.editScreen.bind(this)}
                affiliations={this.state.affiliations}
                data={this.state.data}
                tdddHistory={this.state.tdddHistory}
                submit={this.submitEdit.bind(this)}
                change={this.state.change}
                close={this.closeEdit.bind(this)}
                id={id}
                index={i}
                user={this.props.user}
                setChange={this.setChange.bind(this)}
                updateChanges={this.updateChanges.bind(this)}
            />
        })
    }

    editScreenChangeRequest(i, data) {
        this.setState({
            editScreen: <DetailsEdit
                editScreen={this.editScreen.bind(this)}
                affiliations={this.state.affiliations}
                data={this.state.data}
                submit={this.submitEdit.bind(this)}
                change={data}
                close={this.closeEdit.bind(this)}
                index={i}
                user={this.props.user}
                setChange={this.setChange.bind(this)}
                updateChanges={this.updateChanges.bind(this)}
            />
        })
    }

    openTdddEdit() {
    
            this.setState({
                 editScreen: <TdddDetailsEdit close={this.closeTdddEdit.bind(this)} addTDDD={this.addTDDD.bind(this)} />
                })
    }
    closeTdddEdit() {
        this.setState({editScreen: undefined})
    }
    closeTdddSuccess() {
            this.setState({successScreen: undefined,addTdddsuccess: false})
    }
    addTDDD(data) {
            //this.setState({
                //    editScreen: undefined
                //})
        
           let json = {}
            
           json.PROF_ID = this.state.data.PROF_ID
           json.REQUESTOR_ID = this.props.user.email
           json.REQUESTOR_NAME = this.props.user.userName
           json.REQUESTOR_TEAM = this.props.user.team
           json.REQUESTOR_TERR = this.props.user.terr
           json.REQUEST_TYPE = "Add to - TDDD";
           json.EXPIRATION_DATE = data.EXP;
           json.SLN_NUMBER = data.LICENSE;
           json.STATUS = data.STATUS;
           json.STATE = data.STATE;
           json.ORG_ID = this.state.data.ORG_ID;
           json.SUBCAT = data.SUBCAT;
    
           apiFetch('/api/v2/global/change-request', json).then(() => {

                this.setState({
                    addTdddsuccess: true,
                    editScreen: undefined
                            })
            })

    }

    componentDidMount() {
        this.loadChange();
    }

    loadChange() {
        const oid = this.props.match.params.ORG_ID;
        const json = {
            ORG_ID: oid,
            TEAM: this.props.user.role === 'PRT' || this.props.user.role === 'COMMERCIAL DERM' || this.props.user.role === 'PHARMFORCE' || this.props.user.isDermAdmin === 'true' ? '31' : this.props.user.team
        };

        // Core resolves first — render header as soon as it arrives
        apiFetch('/api/v2/details/hco/core', json).then((core) => {
            if (!core || core.length === 0) { this.setState({ pathError: true }); return; }
            const orgID = core[0].ORG_ID;
            if (orgID != oid) {
                this.setState({ pathError: true });
                console.log('OrgID = ' + orgID + ' query string = ' + oid);
                return;
            }
            this.setState({
                data: core[0],
                loaded: true,
                toggleState: {
                    crm:   core[0].UNIVERSE_FLAG === 'Y',
                    spend: core[0].AGGSPEND_FLAG === 'Y',
                    ctms:  core[0].CTMS_FLAG     === 'Y',
                },
            });
        });

        // Secondary sections fire in parallel
        apiFetch('/api/v2/details/hco/affiliations', json).then((d) => {
            let hasTeamAffiliations = false;
            (d || []).forEach(a => { if (a.TEAM_ID == this.props.user.team) hasTeamAffiliations = true; });
            this.setState({ affiliations: d ?? [], hasTeamAffiliations });
        });

        apiFetch('/api/v2/details/hco/change-requests', json)
            .then(d => this.setState({ change: d ?? [] }));

        apiFetch('/api/v2/details/hco/tddd-history', json)
            .then(d => this.setState({ tdddHistory: d ?? [] }));
    }

    setChange() {

        var url = '/api/v2/details/hco/change-Requests';

        apiFetch(url, { ORG_ID: this.state.data.ORG_ID, TEAM: this.props.user.role == 'PRT' || this.props.user.role == 'COMMERCIAL DERM' || this.props.user.isDermAdmin == 'true' ? '31' : this.props.user.team }).then((data) => {
            if (this.state.editScreen) {
                this.editScreen(11)
            }
            this.setState({
                change: data
            })
        })
    }

    updateChanges() {
        this.loadChange()
    }

    close() {
        this.setState({changeViewValue: -1})
    }


    render() {
        let successDialog = this.state.addTdddsuccess ? (<HcoRequestSuccess close={this.closeTdddSuccess.bind(this)} />) : ""
        if (this.state.loaded) {
            return (
                <div className={Styles.Details}>
                    {this.state.editScreen ? this.state.editScreen : ""}
                    <div className={Styles.TopBar}>
                        <div className={Styles.Back} onClick={() => {
                                if (this.props.history.location.state != null && this.props.history.location.state.from === '/hco') {
                                    this.props.history.push({
                                        pathname: '/hco',
                                        state: {
                                            from: '/hco/details'
                                        }
                                    })
                                }
                                else {
                                    this.props.history.go(-1)
                                }
                            }}><span aria-hidden="true">‹</span>BACK TO SEARCH</div>
                    </div>
                    <div className={Styles.pageWrapper}>
                        <div className={Styles.Wrapper}>
                            {this.state.data
                                ? <DetailsInformation hasAffiliations={this.state.hasTeamAffiliations} editScreen={this.editScreen.bind(this)} submitEdit={this.submitEdit.bind(this)} user={this.props.user} data={{ ...this.state.data, ...this.state.toggleState }} loadChange={this.loadChange.bind(this)} number={this.props.number} addresses={[]} msl={this.state.msl} addTo={this.addTo.bind(this)}/>
                                : <Loading />}
                        </div>
                        <div className={Styles.Wrapper}>
                            <AddressAlignment />
                        </div>
                        <div className={Styles.Wrapper}>
                            <DetailsAffiliations editScreen={this.editScreen.bind(this)} user={this.props.user} data={this.state.affiliations}/>
                        </div>
                        <div className={Styles.Wrapper}>
                            <TdddDetails user={this.props.user} data={this.state.tdddHistory} addTDDD={this.openTdddEdit.bind(this)} />
                        </div>
                        <div className={Styles.Wrapper}>
                            <DetailsChangeRequests data={this.state.change} prev={this.props.data} editScreen={this.editScreenChangeRequest.bind(this)}/>
                        </div>
                    </div>
                    {successDialog}
                </div>
            );
        }
        else {
            if (this.state.pathError) {
                return (<div ><br />&nbsp;&nbsp;Error loading data.  Please refresh the page.</div>)
            } else {
                return (<Loading />)
            }
        }
    }
}

export default withAITracking(reactPlugin, withRouter(HcoDetails));